/* eslint-disable max-len */
import React from 'react';

export const ToastWarningIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M10 10.7497V7.01173M10 13.5203V13.5532M14.7249 16.6663H5.27506C3.98425 16.6663 2.89494 15.8132 2.55221 14.6461C2.40591 14.1479 2.58567 13.6289 2.86063 13.1871L7.58557 4.66719C8.69258 2.88828 11.3074 2.88828 12.4144 4.6672L17.1394 13.1871C17.4143 13.6289 17.5941 14.1479 17.4478 14.6461C17.1051 15.8132 16.0157 16.6663 14.7249 16.6663Z"
			stroke="#FA8B00"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default ToastWarningIcon;
